<app-sidebar></app-sidebar>
<app-mobile-header></app-mobile-header>
<div class="main-validate-email">
  <div class="container">
    <div class="left-section">
      <img src="/assets/logo_2x.png" alt="Conectio Logo" class="logo">
      <h2 style = "font-weight: 600;">{{ 'validateEmail.title' | translate }}<br><span style="color: #7712E3!important;font-weight: 600;">{{ 'validateEmail.subtitle' | translate }} </span></h2>
      <p>{{ 'validateEmail.description' | translate }}</p>
      <p>{{ 'validateEmail.notReceived' | translate }} <a href="javascript:void(0)" (click)="resendVerificationEmail()" style="color: #7252d3!important;">{{ 'validateEmail.resendLink' | translate }}</a> {{ 'validateEmail.resendText' | translate }}
      </p>
      <div *ngIf="isLoading" class="loader">
        <img src="/assets/spinner.gif" [alt]="'validateEmail.loading' | translate" style="width: 45px; height: 45px;">
      </div>
      <div *ngIf="emailSent" class="confirmation">{{ 'validateEmail.emailResent' | translate }}</div>
    </div>
    <div class="right-section">
      <img src="/assets/iphone-validate.png" alt="Illustration" class="illustration">
    </div>
  </div>
</div>
